module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsValentine.f94f84b.jpg";